import React, { CSSProperties } from "react";
import { HiX } from "react-icons/hi";

type PROPS = {
  text: string;
  width?: string;
  color?: string;
  textColor?: string;
  onRemove?: () => void;
  maxWidth?: string;
};

const Chip: React.FC<PROPS> = (props) => {
  const style: CSSProperties = {};
  if (props.width) {
    style.width = props.width;
  }
  if (props.maxWidth) {
    style.maxWidth = props.maxWidth;
  }
  if (props.color) {
    style.backgroundColor = props.color;
  } else {
    style.backgroundColor = "#6c6c6c";
  }
  if (props.textColor) {
    style.color = props.textColor;
  } else {
    style.color = "#ffffff";
  }

  return (
    <div
      className="bg-gray-300 rounded-full px-2 py-1 flex justify-center items-center"
      style={style}
      title={props.text}
    >
      <span className="whitespace-nowrap text-sm overflow-x-hidden text-ellipsis">
        {props.text}
      </span>
      {props.onRemove && (
        <button
          className="ml-2 rounded-xl hover:bg-gray-400"
          onClick={props.onRemove}
        >
          <HiX />
        </button>
      )}
    </div>
  );
};

export default Chip;
